import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { SCAMP_API, SCAMP_API_RPT } from "src/environments/environment";
import { RetornoApi } from "../models/retornoApi.model";
import { SpvParaOS } from "../models/spv-para-OS-model";
import { AccountService } from "./account.service";
import { APP_SETTINGS } from "src/environments/environment";
import { UploadPhoto } from "../pages/os/fechar-os/upload-photo.model";
import { OSTipoViewModel } from "../pages/domain/viewmodels.models";

@Injectable({ providedIn: "root" })
export class OSService {
  constructor(
    private http: HttpClient,
    private account: AccountService,
  ) {}

  getSpvsParaOS(
    empreiteiraId: number,
    encarregadoResponsavelId: number,
    tipoProgramacao: string,
  ): Observable<SpvParaOS[]> {
    return this.http.get<SpvParaOS[]>(
      `${SCAMP_API.accountApiV1}/spvs-para-os/${empreiteiraId}/${encarregadoResponsavelId}/${tipoProgramacao}/${APP_SETTINGS.tipoInstalacao}`,
      { headers: this.account.composeHeaders() },
    );
  }

  getOSsParaFechar(parameters: any): Observable<SpvParaOS[]> {
    parameters.tipoInstalacao = APP_SETTINGS.tipoInstalacao;
    console.log('parameters: ', parameters);  
    return this.http.post<SpvParaOS[]>(
      `${SCAMP_API.accountApiV1}/oss-para-fechar`,
      parameters,
      { headers: this.account.composeHeaders() },
    );
  }

    getOSsParaFecharQtd(parameters: any): Observable<number> {
    parameters.tipoInstalacao = APP_SETTINGS.tipoInstalacao;
    return this.http.post<number>(
      `${SCAMP_API.accountApiV1}/oss-para-fechar-qtd`,
      parameters,
      { headers: this.account.composeHeaders() },
    );
  }

  getOSsPorPTIdOuSpvAprovadoId(Ids: string): Observable<any[]> {
    return this.http.post<any[]>(
      `${SCAMP_API.accountApiV1}/oss/os-por-ptid-spvaprovadoid`,
      { Ids: Ids },
      { headers: this.account.composeHeaders() },
    );
  }

  gerarOSs(data: any): Observable<any> {
    return this.http.post(`${SCAMP_API.accountApiV1}/gerar-oss`, data, {
      headers: this.account.composeHeaders(),
    });
  }

  editarOS(osEditada: any, osCompleta: any): Observable<any> {
    osEditada.colaboradores = osCompleta.spvCompleto.colaboradores.map((t) => {
      return {
        oSId: osCompleta.osId,
        spvAprovadoId: osCompleta.spvCompleto.spvAprovadoId,
        ptId: osCompleta.spvCompleto.ptId,
        funcionarioId: t.id,
        dataHoraInicio: t.dataHoraInicio,
        dataHoraFim: t.dataHoraFim,
        categoriaId: t.categoriaId,
        valor: t.valor,
      };
    });

    osEditada.irregularidades = osCompleta.irregularidades;
    osEditada.uploadPhotos = osCompleta.uploadPhotos;
    osEditada.materiaisUsado = osCompleta.materiaisUsado;

    return this.http.post(`${SCAMP_API.accountApiV1}/oss/editar`, osEditada, {
      headers: this.account.composeHeaders(),
    });
  }

  consultarOSs(data: any): Observable<any> {
    return this.http.post(`${SCAMP_API.accountApiV1}/consultar-oss`, data, {
      headers: this.account.composeHeaders(),
    });
  }

  getOSparaAvaliar(): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/oss-para-validar`, {
      headers: this.account.composeHeaders(),
    });
  }

  getOSCompleta(osid: number, spvId: number): Observable<any> {
    return this.http.get<any>(
      `${SCAMP_API.accountApiV1}/os-completa/${osid}/${Number(spvId)}`,
    );
  }

  cancelarOS(osid: string): Observable<boolean> {
    return this.http.post<boolean>(
      `${SCAMP_API.accountApiV1}/cancelar-os/${osid}`,
      null,
    );
  }

  qualificarOS(osid: string): Observable<boolean> {
    return this.http.post<boolean>(
      `${SCAMP_API.accountApiV1}/qualificar-os/${osid}`,
      null,
    );
  }

  setStatusOS(osid: number, status: number): Observable<boolean> {
    return this.http.post<boolean>(
      `${SCAMP_API.accountApiV1}/set-status-os/${osid}/${status}`,
      null,
    );
  }

  setStatusOSAberta(osid: number): Observable<boolean> {
    return this.http.post<boolean>(
      `${SCAMP_API.accountApiV1}/set-status-os-aberta/${osid}`,
      null,
    );
  }

  // Servidor de Relatórios
  imprimirOS(
    osid: number,
    tipoOSFilha: number,
    imprimirEvidenciaDeFotos: string,
  ): Observable<RetornoApi> {
    return this.http.get<RetornoApi>(
      `${SCAMP_API_RPT.accountApiV1}/rpt-os/${osid}/${tipoOSFilha}/${imprimirEvidenciaDeFotos}`,
    );
  }

  imprimirOSMerge(osTipos: OSTipoViewModel[]): Observable<RetornoApi> {
    return this.http.post<RetornoApi>(
      `${SCAMP_API_RPT.accountApiV1}/rpt-os-merge`,
      osTipos,
    );
  }

  GetOSsStatusExecutada(): Observable<SpvParaOS[]> {
    return this.http.get<SpvParaOS[]>(
      `${SCAMP_API.accountApiV1}/lista-oss-executadas/`,
      { headers: this.account.composeHeaders() },
    );
  }

  GetTiposOSs(): Observable<any[]> {
    return this.http.get<any[]>(`${SCAMP_API.accountApiV1}/oss/tipos-oss`, {
      headers: this.account.composeHeaders(),
    });
  }

  exportarToExcel(parametros: any): Observable<any> {
    return this.http.post<any>(
      `${SCAMP_API.accountApiV1}/oss/emitidas/excel`,
      parametros,
      { headers: this.account.composeHeaders() },
    );
  }

  removerUploadPhoto(uploadPhotoId: number) {
    return this.http.delete(
      `${SCAMP_API.accountApiV1}/upload-photo/remove/${Number(uploadPhotoId)}`,
      { headers: this.account.composeHeaders() },
    );
  }

  imprimirOSMaterialUtilizado(osids: string): Observable<RetornoApi> {
    return this.http.post<RetornoApi>(
      `${SCAMP_API_RPT.accountApiV1}/rpt-osmaterialutilizado`,
      { OSIds: osids },
    );
  }

  getMaterialUtilizadoExcel(osids: string): Observable<any> {
    return this.http.post<any>(
      `${SCAMP_API.accountApiV1}/oss/material-utilizado/excel`,
      { OSIds: osids },
      { headers: this.account.composeHeaders() },
    );
  }

  imprimirOSFuncionarioAtuante(osids: string): Observable<RetornoApi> {
    return this.http.post<RetornoApi>(
      `${SCAMP_API_RPT.accountApiV1}/rpt-osfuncionariosatuantes`,
      { OSIds: osids },
    );
  }

  imprimirOs(osids: string): Observable<RetornoApi> {
    return this.http.post<RetornoApi>(`${SCAMP_API_RPT.accountApiV1}/rpt-os`, {
      OSIds: osids,
    });
  }
}
